import React, { useState } from 'react'
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage'
import InputField from '../../components/InputField/InputField'
import Button from '../../components/Button/Button'
import { useNavigate } from 'react-router-dom';

export default function LoginLocation() {
    const navigate = useNavigate();
    const [locationName, setLocationName] = useState("");
    return (
        <div>
            <WelcomeMessage message="Lütfen buluduğunuz lokasyon bilgisini onaylayın." />
            <div style={{ marginTop: '25px' }}>
                <InputField onChange={(e) => setLocationName(e.target.value)}
                value={locationName} label={"Lokasyon Bilgisi"} placeholder={"Bulunulan AVM ya da Mekan Adı"} />
            </div>
            <Button
                label="Devam et"
                variant="primary"
                style={{ width: '100%', marginTop: '32px', height: '44px' }}
                disabled={!locationName}
                onClick={() => navigate('/login-phone')}
            />
        </div>

    )
}
